import React from "react";
import Accordion from "./Accordion";
/**
 *
 * @param {Array} props.result an array of data to be mapped.
 * @returns a component that renders data from `props.result`.
 */

const StudentsCard = ({ results }) => {
  return (
    <>
      {results.map(item => (
        <div key={item.firstName} className="inner-container">
          <div className="avatar-container">
            <img className="avatar" src={item.pic} alt={item.firstName} />
          </div>
          <Accordion item={item} />
        </div>
      ))}
    </>
  );
};

export default StudentsCard;
